import { useMemo } from 'react';
import { TreeNavigatorLogic } from '../../../../tree/navigation/TreeNavigatorLogic';
import {
  IRootWidgetIdentifier,
  useTreeReferencesGlobalContext,
} from '../../../../tree/references/TreeReferencesGlobalContext';
import { hasCode } from '../../ICodeWidget';

/**
 * Funzione che passata la lista di identificatori delle root di tutte le sezioni,
 * restituisce una mappa che ha come chiave il codice del widget e come valore
 * la lista degli id dei widget che hanno quel codice.
 *
 * Utilizzata per la gestione della validazione dell'unicità del codice dei widget.
 */
export function extractAllCodesMap(
  allRoots: IRootWidgetIdentifier[] | undefined,
) {
  const allCodes = new Map<string, string[]>();
  if (!allRoots) return { allCodes };

  allRoots.forEach(root => {
    const tree = root.root;

    TreeNavigatorLogic.forEachNode(tree, node => {
      if (!hasCode(node)) return;
      const oldValue = allCodes.get(node.code) ?? [];

      allCodes.set(node.code, [...oldValue, node.id]);
    });
  });

  return { allCodes };
}

export function useConfigValidationContext(baseContext?: Record<string, any>) {
  const globalContext = useTreeReferencesGlobalContext();

  const context = useMemo(() => {
    return extractAllCodesMap(globalContext?.allRoots);
  }, [globalContext]);

  return { ...context, ...baseContext };
}

export type IConfigValidationContext = ReturnType<
  typeof useConfigValidationContext
>;
